import { useState, useEffect } from "react";
import { getBondCharacteristics } from "../../http/api";

export const useBondCharacteristics = (token, page = 0, size = 20, columnToSort = "characteristicMstId", sortingDirection = "desc", visitedTabs = new Set(), setVisitedTabs = () => {}, tabId = "0-1") => {
  const [bondCharData, setBondCharData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Skip API call if token is null (meaning this tab is not active)
    if (!token) return;

    // Check if we've already visited this tab and page combination
    // If we have, don't make the API call again
    // const tabPageKey = `${tabId}-${page}-${size}`;
    const tabPageKey = `${tabId}-${page}-${size}`;

    if (visitedTabs.has(tabPageKey)) {
      return;
    }

    const fetchBondCharacteristics = async () => {
      setLoading(true);
      try {
        const response = await getBondCharacteristics(token, page, size, columnToSort, sortingDirection);
        setBondCharData(response.content || []);
        setTotalElements(response.totalElements || 0);
        
        // Mark this tab-page combination as visited by replacing any existing entries for this tab
        setVisitedTabs(prev => {
          const newSet = new Set(prev);
          // Remove any previous entries for this tab (regardless of page)
          Array.from(prev).forEach(key => {
            if (key.startsWith(`${tabId}-`)) {
              newSet.delete(key);
            }
          });
          // Add the current tab-page combination
          newSet.add(tabPageKey);
          return newSet;
        });
      } catch (error) {
        console.error("Error fetching bond characteristics:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchBondCharacteristics();
  }, [token, page, size, columnToSort, sortingDirection, tabId, visitedTabs, setVisitedTabs]);

  useEffect(() => {
    const userRole = localStorage.getItem("role");
    const userId = localStorage.getItem("userId");

    const handleCharUpdate = (event) => {
      const newChar = event.detail;
      setBondCharData((prevChars) => {
        const existingCharIndex = prevChars.findIndex(
          (char) => char.characteristicId === newChar.characteristicId
        );
        if (existingCharIndex !== -1) {
          const updatedChars = [...prevChars];
          updatedChars[existingCharIndex] = newChar;
          return updatedChars;
        }
        return [newChar, ...prevChars];
      });
    };

    const handlePmCharUpdate = (event) => {
      const newChar = event.detail;
      setBondCharData((prevChars) => {
        const existingCharIndex = prevChars.findIndex(
          (char) => char.characteristicId === newChar.characteristicId
        );
        if (existingCharIndex !== -1) {
          const updatedChars = [...prevChars];
          updatedChars[existingCharIndex] = newChar;
          return updatedChars;
        }
        return [newChar, ...prevChars];
      });
    };

    window.addEventListener("characteristicUpdate", handleCharUpdate);
    return () => {
      window.removeEventListener("characteristicUpdate", handleCharUpdate);
    };
  }, []);

  return { bondCharData, setBondCharData, totalElements, loading };
};